module.exports = __webpack_public_path__ + "img/guan.08ddbceb.png";